import { z } from "zod";

export const storeDeviceMessagePayloadSchema = z.object({
  BatteryCurrent: z.number().optional(),
  BatteryVoltage: z.number().optional(),
  CodecId: z.number().optional(),
  ChannelId: z.number(),
  DeviceId: z.number().optional(),
  DeviceName: z.string().optional(),
  DeviceTypeId: z.number().optional(),
  EngineIgnitionStatus: z.boolean().optional(),
  EventPriorityEnum: z.number().optional(),
  ExternalPowersourceVoltage: z.number().optional(),
  GnssStateEnum: z.number().optional(),
  GnssStatus: z.boolean().optional(),
  GsmMcc: z.number().optional(),
  GsmMnc: z.number().optional(),
  GsmOperatorCode: z.string().optional(),
  GsmSignalLevel: z.number().optional(),
  CanDtcNumber: z.number().optional(),
  CanEngineCoolantTemperature: z.number().optional(),
  CanEngineLoadLevel: z.number().optional(),
  CanEngineOilTemperature: z.number().optional(),
  CanEngineRpm: z.number().optional(),
  CanFuelConsumption: z.number().optional(),
  CanFuelLevel: z.number().optional(),
  CanFuelVolume: z.number().optional(),
  CanMilMileage: z.number().optional(),
  CanVehicleMileage: z.number().optional(),
  CanVehicleSpeed: z.number().optional(),
  Ident: z.string(),
  MovementStatus: z.boolean().optional(),
  PositionAltitude: z.number().optional(),
  PositionDirection: z.number().optional(),
  PositionHdop: z.number().optional(),
  PositionLatitude: z.number(),
  PositionLongitude: z.number(),
  PositionPdop: z.number().optional(),
  PositionSatellites: z.number().optional(),
  PositionSpeed: z.number(),
  PositionValid: z.boolean().optional(),
  RestTimestamp: z.number().optional(),
  SleepModeEnum: z.number().optional(),
  Timestamp: z.number(),
  VehicleMileage: z.number(),
  VehicleVin: z.string().optional(),
});

export type StoreDeviceMessagePayload = z.infer<
  typeof storeDeviceMessagePayloadSchema
>;
